export default __webpack_public_path__ + "static/media/img10.95bf1f6e.jpg";